"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COVER_WRAP_SIZE = exports.BookPageDimensions = exports.BookTextFonts = exports.BookTextStyle = exports.BookSize = void 0;
var BookSize;
(function (BookSize) {
    BookSize["BOOK_8X8"] = "BOOK_8X8";
    BookSize["BOOK_10X10"] = "BOOK_10X10";
    BookSize["BOOK_12X12"] = "BOOK_12X12";
})(BookSize = exports.BookSize || (exports.BookSize = {}));
var BookTextStyle;
(function (BookTextStyle) {
    BookTextStyle["Minimalist"] = "Minimalist";
    BookTextStyle["Classic"] = "Classic";
    BookTextStyle["Handwriting"] = "Handwriting";
    BookTextStyle["BOLD"] = "BOLD";
})(BookTextStyle = exports.BookTextStyle || (exports.BookTextStyle = {}));
exports.BookTextFonts = {
    [BookTextStyle.Minimalist]: { fontFamily: 'MixtilesSans', fontWeight: 500 },
    [BookTextStyle.Classic]: { fontFamily: 'Castoro', fontWeight: 400 },
    [BookTextStyle.Handwriting]: { fontFamily: 'Caveat', fontWeight: 400 },
    [BookTextStyle.BOLD]: { fontFamily: 'Bebas Neue', fontWeight: 400 },
};
exports.BookPageDimensions = {
    [BookSize.BOOK_8X8]: { pageWidth: 8.25, pageHeight: 8.25, bleedSize: 0.125 },
    [BookSize.BOOK_10X10]: { pageWidth: 10.25, pageHeight: 10.25, bleedSize: 0.125 },
    [BookSize.BOOK_12X12]: { pageWidth: 12.05, pageHeight: 12.05, bleedSize: 0.125 },
};
// Size of the paper which is being wrap behind the cover (in inches)
exports.COVER_WRAP_SIZE = 0.75;
//# sourceMappingURL=photoBooks.js.map